
import { BookOpen, Book, UsersRound } from "lucide-react";

interface AcademyStatsProps {
  mentees: number;
  totalCourses: number;
  activeCourses: number;
}

const AcademyStats = ({ mentees, totalCourses, activeCourses }: AcademyStatsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 font-medium">Mentees</h3>
          <div className="p-2 bg-blue-100 rounded-md">
            <UsersRound className="h-5 w-5 text-emu-blue" />
          </div>
        </div>
        <p className="text-3xl font-bold">{mentees}</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 font-medium">Courses</h3>
          <div className="p-2 bg-blue-100 rounded-md">
            <BookOpen className="h-5 w-5 text-emu-blue" />
          </div>
        </div>
        <p className="text-3xl font-bold">{totalCourses}</p>
      </div>
      
      <div className="bg-white rounded-lg shadow-sm border p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-gray-500 font-medium">Active Courses</h3>
          <div className="p-2 bg-blue-100 rounded-md">
            <Book className="h-5 w-5 text-emu-blue" />
          </div>
        </div>
        <p className="text-3xl font-bold">{activeCourses}</p>
      </div>
    </div>
  );
};

export default AcademyStats;
